/*
  entry point for playerStats.php - show win / loss record for all players
*/
import $ from 'jquery';

$(function () {
  getStats();

  const $statFilters = $('#statFilters');
  if ($statFilters.length !== 1) {
    console.warn('Unable to attach to filters');
  }

  // configure interface actions;
  // change season
  $statFilters.find('select').on('change', function (e) {
    // update($statFilters);
    getStats();
  });

  /*
  $('select[name="event"]').on('change', function (e) {
    const seasonId = $('select[name="seasonId"]').val();
    const eventName = $('select[name="event"]').val();
    const division = $('select[name="division"]').val();
    getStats(seasonId, eventName, division);
  });

  $('select[name="division"]').on('change', function (e) {
    const seasonId = $('select[name="seasonId"]').val();
    const eventName = $('select[name="event"]').val();
    const division = $('select[name="division"]').val();
    getStats(seasonId, eventName, division);
  });
  */
});

function update ($statFilters) {
  const seasonId = parseInt($statFilters.find('select[name="seasonId"]').val());
  const eventName = $statFilters.find('select[name="event"]').val();
  const division = parseInt($statFilters.find('select[name="division"]').val());

  // getStats(seasonId, eventName, division);
  return { 'seasonId': seasonId, 'event': eventName, 'division': division };
}

/**
 *
 * @param {int} seasonId
 * @param {*} event
 * @param {int} division
 *
 * parameter values of 0 indicate "All"
 */
function getStats (seasonId = 0, event = 0, division = 0) {
  const params = { 'seasonId': seasonId, 'event': event, 'division': division };
  console.log('getStats(%o)', params);

  // check the empty table structure exists
  const $playerStats = $('#playerStatsTable');
  if ($playerStats.length !== 1) {
    console.error('Missing table');
    return false;
  }

  // build or refresh the data table
  if ($.fn.dataTable.isDataTable('#playerStatsTable')) {
    const statsDT = $playerStats.DataTable();
    statsDT.ajax.reload();
  } else {
    $playerStats.DataTable({
      'ajax': {
        'data': function (d) {
          const $statFilters = $('#statFilters');
          const params = update($statFilters);
          d.seasonId = params.seasonId;
          d.event = params.event;
          d.division = params.division;
        },
        'dataSrc': 'players',
        'dataType': 'json',
        'error': function (xhr, textStatus, error) {
          switch (xhr.status) {
            case 400:
              // Bad request -- probably missing params
              $playerStats.find('td.dataTables_empty').html('<span>Error</span>');
              break;
            case 401:
              // 'Unauthorized' -- probably the session ended, reload should bounce us to the login page retaining the URL
              document.location.reload();
              break;
            case 403:
              // 'Forbidden' -- indicates the user did not have permission -- not admin?
              document.location.reload();
              break;
            case 404:
              // Not Found -- bad request URL
              $playerStats.find('td.dataTables_empty').html('<span>Error</span>');
              break;
            case 500:
              // server side crash
              $playerStats.find('td.dataTables_empty').html('<span>Error</span>');
              break;
            default:
              // others
          }
          console.log('%o %o %o', xhr, textStatus, error);
        },
        'type': 'GET',
        'url': 'database/getPlayerStats.php'
      },
      'columns': [
        { 'data': 'playerId', 'visible': false },
        { 'data': 'fullName' },
        {
          'data': null,
          'render': function (data, type) {
            return data.hRubbers + data.aRubbers;
          }
        },
        {
          'data': null,
          'render': function (data, type) {
            return data.hWins + data.aWins;
          }
        },
        {
          'data': null,
          'render': function (data) {
            const winRatio = ((data.hWins + data.aWins) / (data.hRubbers + data.aRubbers) * 100).toFixed(0) + '%';
            return winRatio;
          }
        }
      ],
      // 'dom': 'Pfrtip',
      'language': { 'emptyTable': 'There are no records available' },
      'order': [[4, 'desc']],
      'responsive': true,
      'stateSave': true
    });
  }
}
